<template>
  <div>
    <v-row class="mt-2 ma-0">
      <!-- Logo and Top Text -->
      <v-col cols="12" md="3" class="d-flex flex-column align-center text-center">
        <ImageLogo class="d-block mt-2" />
        <Element
          v-if="topText?.[0] && (topText[0].rawText || topText[0].tagName)"
          v-bind="topText[0]"
          class="mx-3 mx-lg-0"
        />
      </v-col>

      <!-- Links -->
      <v-col v-if="hasLinks" cols="12" :md="linksColMd">
        <v-row class="mx-2">
          <v-col v-for="(link, i) in links" :key="i" class="footer-links" cols="12" md="6">
            <SmartLink v-if="link.uri" :to="link.uri">{{ link.label }}</SmartLink>
            <span v-else class="inner-link">{{ link.label }}</span>
          </v-col>
        </v-row>
      </v-col>

      <!-- Structurizer -->
      <v-col v-if="showHubs" cols="12" :md="structurizerColMd" class="structurizer pt-0">
        <StructurizerTree />
      </v-col>
    </v-row>

    <div class="text-center my-2 copyright">
      <div>Copyright © {{ currentYear }}. All Rights Reserved.</div>
    </div>
  </div>
</template>

<script setup>
const page = inject("page");
const props = defineProps({
  links: { type: Array, required: false, default: () => [] },
  topText: { type: Object, required: false, default: () => ({}) },
  bottomText: { type: Array, required: false, default: () => [] },
  showHubs: { type: Boolean, required: false, default: true },
});

const showHubs = computed(() => props.showHubs && unref(page).structurizer);
const hasLinks = computed(() => props.links && props.links.length);

const linksColMd = computed(() => (showHubs.value ? 6 : 9));
const structurizerColMd = computed(() => (hasLinks.value ? 3 : 9));

const date = new Date();
const currentYear = date.toLocaleString("default", { year: "numeric" });
const links = props.links;
const topText = props.topText;
</script>
